import React, { useState, useEffect,useRef } from "react";
import bg from "../img/bg-hero.jpg";
import bg2 from "../img/booking.jpg";
import { SlBadge } from 'react-icons/sl';
import { DiReact } from 'react-icons/di'
import { FaGlobe } from 'react-icons/fa';
import {  FaUsers } from 'react-icons/fa';
import Form from '../components/Form'
import { Helmet } from 'react-helmet-async'

const IndustryCard = ({ title, imgSrc, shortText, longText, delay }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={`col-lg-4 col-md-6 wow fadeInUp`} data-wow-delay={delay}>
      <div className="package-item">
        <div className="overflow-hidden">
          <img className="img-fluid" src={imgSrc} alt={title} width={360} height={360}/>
        </div>
        <div className="text-center p-4">
          <h3 className="mb-0">{title}</h3>
          <p>
            {shortText}
            {isExpanded && <span>{longText}</span>}
          </p>
          <button className="btn btn-primary btn-sm" onClick={toggleReadMore}>
            {isExpanded ? 'Read Less' : 'Read More'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default function Home() {
  const [bgImage, setBgImage] = useState(bg);
  const industries = [
    {
      title: 'Healthcare',
      imgSrc: 'https://thumbs.dreamstime.com/b/dreamstime-template-198954292.jpg',
      shortText: 'We provide complete web & mobile app development solutions to the Healthcare industry.',
      longText:
        ' Our IT solutions effectively enhance operational efficiencies and improve internal processes. We also ensure secure data handling, integration with medical devices, and compliance with industry regulations.',
      delay: '0.1s',
    },
    {
      title: 'Retail & eCommerce',
      imgSrc: 'https://cdn.dribbble.com/userupload/17039932/file/original-983633d1f6de58f5d871f174ff34f057.jpg?format=webp&resize=600x550&vertical=center',
      shortText: 'We provide complete web & mobile app development solutions to Retail & eCommerce.',
      longText:
        ' Our IT solutions effectively enhance operational efficiencies and improve internal processes.',
      delay: '0.3s',
    },
    {
      title: 'Travel & Tourism',
      imgSrc: 'assets/img/ind3.png',
      shortText: 'We provide complete web & mobile app development solutions to Travel & Tourism.',
      longText:
        ' Our IT solutions effectively enhance operational efficiencies and improve internal processes.',
      delay: '0.5s',
    },
    {
      title: 'Logistics & Transportation',
      imgSrc: 'https://easy-peasy.ai/cdn-cgi/image/quality=80,format=auto,width=700/https://fdczvxmwwjwpwbeeqcth.supabase.co/storage/v1/object/public/images/1371375c-3cb7-45ff-90db-771fdc8b15eb/7b5e78bf-acb2-44d1-afed-4674a3f427f3.png',
      shortText:
        'We provide complete web & mobile app development solutions to Logistics & Transportation industry.',
      longText:
        ' Our IT solutions effectively enhance operational efficiencies and improve internal processes.',
      delay: '0.7s',
    },
    {
      title: 'Technology',
      imgSrc: 'https://thumbs.dreamstime.com/b/vector-circuit-board-bulb-concept-information-technology-logo-74487481.jpg',
      shortText:
        'We deliver innovative web and mobile app development solutions tailored to the technology industry.',
      longText:
        'Our IT services empower businesses to streamline operations, drive innovation, and stay ahead in the ever-evolving tech landscape.',
      delay: '0.7s',
    },
    
    {
      title: 'Finance',
      imgSrc: 'https://media.istockphoto.com/id/1256964435/vector/money-logo-designs-template-vector-finance-logo-designs-vector-logo-symbol-icon.jpg?s=612x612&w=0&k=20&c=VxWy9fV8yH1wWaomyW-doWS1-hpW0ybNMUjSSSzvQtI=',
      shortText:
        'We offer tailored web and mobile app development solutions for the Finance industry.',
      longText:
        'Our IT solutions enhance financial operations, improve decision-making, and ensure secure and efficient digital transactions.',
      delay: '0.7s',
    },
    
    {
      title: 'Education',
      imgSrc: 'https://static.vecteezy.com/system/resources/thumbnails/005/601/782/small_2x/world-education-logo-design-vector.jpg',
      shortText:
        'We deliver innovative web and mobile app solutions tailored for the Education sector.',
      longText:
        'Our IT solutions revolutionize learning experiences, streamline administrative processes, and enhance accessibility to educational resources.',
      delay: '0.7s',
    },
    
    {
      title: 'Industrial Automation',
      imgSrc: 'assets/img/ind5.png',
      shortText:
        'We provide complete web & mobile app development solutions to Industrial Automation industry.',
      longText:
        ' Our IT solutions effectively enhance operational efficiencies and improve internal processes.',
      delay: '0.9s',
    },
    {
      title: 'Church Application',
      imgSrc: 'assets/img/ind6.png',
      shortText:
        'Our services are designed to enhance engagement, streamline communication, and support the unique needs of faith-based ',
      longText:
        'Communities by leveraging technology, we aim to help religious institutions expand their reach and effectively connect with their congregations.',
      delay: '1s',
    },
  ];

  useEffect(() => {
    const images = [bg, bg2]; // Array of image imports

    let currentIndex = 0;

    const interval = setInterval(() => {
      currentIndex = (currentIndex + 1) % images.length; // Cycle through images
      setBgImage(images[currentIndex]); // Set the current image
    }, 2000); // Change every 2 seconds

    return () => clearInterval(interval); // Cleanup on component unmount
  }, []);


  return (
    <>
    <Helmet>
      <title>Home-NagsPro</title>
      <meta name="description" content="North Atlantic Global Services (NAGS) is a multi-competency technology consulting firm with expertise and capability across many industries and business functions to help clients optimize their performance and profitability."/>
      <link rel="canonical" href="/"/>
    </Helmet>
    <div>
  {/* Hero section */}
      <div className="container-fluid bg-primary py-5 mb-5 hero-header2">
      {/* <div>
      <audio ref={audioRef} src="path_to_your_audio_file/welcome_to_NagsPro.mp3" preload="auto" />
    </div> */}
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white mb-3 animated slideInDown">
              We Transform Ideas Into Fully Realized Productions.
              </h1>
              <p className="fs-3 text-white mb-4 animated slideInDown">
              Turn your ideas into reality with our professional software development services.
               From initial concept to final deployment, we craft tailored solutions designed 
               to meet your specific business needs.
              </p>
              {/* <div className="position-relative w-75 mx-auto animated slideInDown">
                <input
                  className="form-control border-0 rounded-pill w-100 py-3 ps-4 pe-5"
                  type="text"
                  placeholder="Eg: Thailand"
                />
                <button
                  type="button"
                  className="btn btn-primary rounded-pill py-2 px-4 position-absolute top-0 end-0 me-2"
                  style={{ marginTop: 7 }}
                >
                  Search
                </button>
              </div> */}
         <div className="d-flex justify-content-center align-items-center w-75 mx-auto animated slideInDown">
          <a href="/Certifications">
         <button
  type="button"
  className="btn btn-primary rounded-pill py-2 px-4 me-2 custom-btn"
  style={{ marginTop: 7, width: "200px" }}
>
I.T Training
</button>
</a>
&nbsp;
&nbsp;
<a href="/Contact">
<button
  type="button"
  className="btn btn-dark rounded-pill py-2 px-4 custom-btn"
  style={{ marginTop: 7, width: "200px" }}
>
  Contact Us
</button>
</a>
</div>

            </div>
          </div>
        </div>
      </div>
 {/* End  Hero section */}

 <div className="containerss">

 <div className="card">
    <div className="icon bg-orange">
      <FaUsers className="icon-style" />
    </div>
    <h6 className="statistic text-orange">250+</h6>
    <p className="description">Happy Clients</p>
  </div>

  <div className="card">
    <div className="icon bg-green">
    <DiReact className="icon-style" />
    </div>
    <h6 className="statistic text-green">40+</h6>
    <p className="description">Technology Partners</p>
  </div>
  <div className="card">
    <div className="icon bg-cyan">
      <FaGlobe className="icon-style" />
    </div>
    <h6 className="statistic text-cyan">30+</h6>
    <p className="description">Service Portfolio</p>
  </div>

  <div className="card">
    <div className="icon bg-indigo">
      <SlBadge className="icon-style" />
    </div>
    <h6 className="statistic text-indigo">3000+</h6>
    <p className="description">Trained</p>
  </div>

 

</div>


    {/* About Start */}
    <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5">
          <div
            className="col-lg-6 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ minHeight: 400 }}
          >
            <div className="position-relative h-100">
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/abt.jpg"
                alt=""
                style={{ objectFit: "cover" }}
              />
            </div>
          </div>
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
            <h6 className="section-title bg-white text-start text-primary pe-3">
              About Us
            </h6>
            <h1 className="mb-4">
              Welcome to <span className="text-primary">NagsPro</span>
            </h1>
            <p className="mb-4">
            North Atlantic Global Services (NAGS) is a multi-competency technology consulting firm with expertise and capability 
            across many industries and business functions to help clients optimize their performance and profitability.
            </p>
            <p className="mb-4">
            We have built a strong and diverse team with collective industry experience in different sectors such as :
            </p>
            <div className="row gy-2 gx-4 mb-4">
              <div className="col-sm-6">
                <p className="mb-0">
                  <i className="fa fa-arrow-right text-primary me-2" />
                  Healthcare
                </p>
              </div>
              <div className="col-sm-6">
                <p className="mb-0">
                  <i className="fa fa-arrow-right text-primary me-2" />
                  Retail & eCommerce
                </p>
              </div>
              <div className="col-sm-6">
                <p className="mb-0">
                  <i className="fa fa-arrow-right text-primary me-2" />
                  Project Management
                </p>
              </div>
              <div className="col-sm-6">
                <p className="mb-0">
                  <i className="fa fa-arrow-right text-primary me-2" />
                  IT Training
                </p>
              </div>
              <div className="col-sm-6">
                <p className="mb-0">
                  <i className="fa fa-arrow-right text-primary me-2" />
                  Banking & Finance
                </p>
              </div>
              <div className="col-sm-6">
                <p className="mb-0">
                  <i className="fa fa-arrow-right text-primary me-2" />
                  Government Administration
                </p>
              </div>
              <div className="col-sm-6">
                <p className="mb-0">
                  <i className="fa fa-arrow-right text-primary me-2" />
                  IT Security and Audit Solution
                </p>
              </div>
              <div className="col-sm-6">
                <p className="mb-0">
                  <i className="fa fa-arrow-right text-primary me-2" />
                 Church Applications
                </p>
              </div>
            </div>
            <a className="btn btn-primary py-3 px-5 mt-2" href="/About">
              Read More
            </a>
          </div>
        </div>
      </div>
    </div>
    {/* About End */}

    {/* Service Start */}
    <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="section-title bg-white text-center text-primary px-3">
            What we do
          </h6>
          <h1 className="mb-5">Our Services</h1>
        </div>
        <div className="row g-4">
       
          <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-item rounded pt-3">
              <div className="p-4">
            <a href="/auditing" className="black">
                <i className="fa fa-3x fa-tools text-primary mb-4" />
                <h5>Cybersecurity and Audit Consulting Services</h5>
                <p>
                We will help you take care of the technical part while you focus on the business.
                </p>
              </a>
              </div>
            </div>
          </div>
        
          <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.7s">
            <div className="service-item rounded pt-3">
              <div className="p-4" >
              <a href="/it-Support" className="black" >
                <i className="fa fa-3x fa-headset text-primary mb-4" />
                <h5>I.T. Support Service</h5>
                <p>
                  <br/>
                We offer world-class support services customized to fit any size and type of business.
                </p>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="service-item rounded pt-3">
              <div className="p-4">
              <a href="/web_development" className="black">
                <i className="fa fa-3x fa-globe text-primary mb-4" />
                <h5>Web Development and eCommerce Solutions</h5>
                <p>
                Build Web Application with advanced machine learning & artificial intelligence
                </p>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="service-item rounded pt-3">
              <div className="p-4">
              <a href="/Certifications" className="black">
                <i className="fa fa-3x fa-chalkboard-teacher text-primary mb-4" />
                <h5>I.T Training</h5>
                <p>
                <br/>
                We focus on educational content suggests a commitment to providing quality training materials.
                </p>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-item rounded pt-3">
              <div className="p-4">
              <a href="/project_management" className="black">
                <i className="fa fa-3x fa-tasks text-primary mb-4" />
                <h5>Project Management</h5>
                <p>
                <br/>
               Emphasizing best practices to ensure projects are delivered on time and within budget.
                </p>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.7s">
            <div className="service-item rounded pt-3">
              <div className="p-4">
              <a href="/equipment_Maintenance" className="black">
                <i className="fa fa-3x fa-cog text-primary mb-4" />
                <h5>Equipment Supplies and Maintenance</h5>
                <p>
                Custom Software Development with features go beyond traditional methods
                </p>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="service-item rounded pt-3">
              <div className="p-4">
              <a href="#" className="black">
                <i className="fa fa-3x fa-cubes text-primary mb-4" />
                <h5>Blockchain Applications</h5>
                <p>
                <br/>
                <br/>
                Build reliable web3 softwares that meets the market standard
                </p>
                </a>
              </div>
            </div>
          </div>
      
        </div>
      </div>
    </div>
    {/* Service End */}

    {/* project Start */}
    <div className="container-xxl py-5 destination">
      <div className="container">
        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Project
          </h6>
          <h1 className="mb-5">Popular Project</h1>
        </div>
        <div className="row g-3">
          <div className="col-lg-7 col-md-6">
            <div className="row g-3">
              <div
                className="col-lg-12 col-md-12 wow zoomIn"
                data-wow-delay="0.1s"
              >
                <a
                  className="position-relative d-block overflow-hidden"
             
                >
                  <img
                    className="img-fluid"
                    src="https://www.kenfil.com/wp-content/uploads/rear-view-audience-listening-asian-speaker-stage-meeting-room-scaled-e1665477415673.jpg"
                    alt=""
                  />
               
                  <div className="bg-white text-primary fw-bold position-absolute bottom-0 end-0 m-3 py-1 px-2">
                IT Training
                  </div>
                </a>
              </div>
              <div
                className="col-lg-6 col-md-12 wow zoomIn"
                data-wow-delay="0.3s"
              >
                <a
                  className="position-relative d-block overflow-hidden"
               
                >
                  <img
                    className="img-fluid"
                    src="assets/img/img2.jpg"
                    alt=""
                  />
                
                  <div className="bg-white text-primary fw-bold position-absolute bottom-0 end-0 m-3 py-1 px-2">
                    Ecommerce
                  </div>
                </a>
              </div>
              <div
                className="col-lg-6 col-md-12 wow zoomIn"
                data-wow-delay="0.5s"
              >
                <a
                  className="position-relative d-block overflow-hidden"
                
                >
                  <img
                    className="img-fluid"
                    src="https://www.shutterstock.com/shutterstock/photos/1637114059/display_1500/stock-vector-audit-consulting-for-company-website-landing-page-set-auditors-check-sum-documents-bank-accounts-1637114059.jpg"
                    alt=""
                  />
                
                  <div className="bg-white text-primary fw-bold position-absolute bottom-0 end-0 m-3 py-1 px-2">
                  Audit Consulting
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div
            className="col-lg-5 col-md-6 wow zoomIn"
            data-wow-delay="0.7s"
            style={{ minHeight: 350 }}
          >
            <a
              className="position-relative d-block h-100 overflow-hidden"
           
            >
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/philip.jpg"
                alt=""
                style={{ objectFit: "cover" }}
              />
           
              <div className="bg-white text-primary fw-bold position-absolute bottom-0 end-0 m-3 py-1 px-2">
            Equipment Supply
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    {/* project Start */}





    {/* Industies Start */}
    <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Industries
          </h6>
          <h1 className="mb-5">Industries We Serve</h1>
        </div>
        <div className="row g-4 justify-content-center">
          {industries.map((industry, index) => (
            <IndustryCard key={index} {...industry} />
          ))}
        </div>
      </div>
    </div>
    {/* Industies End */}

    {/* Booking Start */}
     <Form/>
    {/* Booking Start */}

    {/* Process Start */}
    <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center pb-4 wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Technologies
          </h6>
          <h1 className="mb-5">Our Technologies</h1>
        </div>
        <div className="row gy-5 gx-4 justify-content-center">
        <div
  className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
  data-wow-delay="0.1s"
>
  <div className="position-relative border border-primary pt-5 pb-4 px-4">
    <div
      className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
      style={{ width: 100, height: 100 }}
    >
      <i className="fa fa-shield-alt fa-3x text-white" />
    </div>
    <h5 className="mt-4">Cyber Security</h5>
    <hr className="w-25 mx-auto bg-primary mb-1" />
    <hr className="w-50 mx-auto bg-primary mt-0" />
    <p className="mb-0">
      Our security experts leverage on state-of-the-art industry tools to analyze and detect real-time threats to your network
      (Splunk, Nessus, FireEye, Wireshark, Palo Alto)
    </p>
  </div>
</div>

<div
  className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
  data-wow-delay="0.1s"
>
  <div className="position-relative border border-primary pt-5 pb-4 px-4">
    <div
      className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
      style={{ width: 100, height: 100 }}
    >
      <i className="fa fa-search-dollar fa-3x text-white" />
    </div>
    <h5 className="mt-4">I.T Audit Consulting</h5>
    <hr className="w-25 mx-auto bg-primary mb-1" />
    <hr className="w-50 mx-auto bg-primary mt-0" />
    <p className="mb-0">
      Streamlining your Audit processes, track findings and ensuring adherence to regulatory requirement is a passion for us (SAP GRC, AuditBoard,
      CyberArk, Ansible, Puppet)
    </p>
  </div>
</div>

<div
  className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
  data-wow-delay="0.1s"
>
  <div className="position-relative border border-primary pt-5 pb-4 px-4">
    <div
      className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
      style={{ width: 100, height: 100 }}
    >
      <i className="fa fa-cloud fa-3x text-white" />
    </div>
    <h5 className="mt-4">Cloud Computing</h5>
    <hr className="w-25 mx-auto bg-primary mb-1" />
    <hr className="w-50 mx-auto bg-primary mt-0" />
    <p className="mb-0">
      With best practices and tools at hand, our Cloud Architects understand scalable solutions, reliable and sure, helping your business grow 
      and endure (AWS, Azure, GCP, Vmware Cloud)
    </p>
  </div>
</div>

<div
  className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
  data-wow-delay="0.1s"
>
  <div className="position-relative border border-primary pt-5 pb-4 px-4">
    <div
      className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
      style={{ width: 100, height: 100 }}
    >
      <i className="fa fa-server fa-3x text-white" />
    </div>
    <h5 className="mt-4">Server and Storage Infrastructure</h5>
    <hr className="w-25 mx-auto bg-primary mb-1" />
    <hr className="w-50 mx-auto bg-primary mt-0" />
    <p className="mb-0">
      Our experts in Server and Storage Infrastructure leverage cutting-edge technologies such as Dell EMC, HPE, NetApp, VMware, 
      and Microsoft Azure to deliver innovative solutions tailored to your business needs.
    </p>
  </div>
</div>

<div
  className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
  data-wow-delay="0.1s"
>
  <div className="position-relative border border-primary pt-5 pb-4 px-4">
    <div
      className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
      style={{ width: 100, height: 100 }}
    >
      <i className="fa fa-graduation-cap fa-3x text-white" />
    </div>
    <h5 className="mt-4">I.T Training</h5>
    <hr className="w-25 mx-auto bg-primary mb-1" />
    <hr className="w-50 mx-auto bg-primary mt-0" />
    <p className="mb-0">
      Our top-notch I.T. Training programs offer expert-led courses in Cisco, Microsoft, AWS, Azure, ISACA, and more, 
      equipping you with the skills and certifications needed to excel in today’s technology-driven world.
    </p>
  </div>
</div>


  <div
    className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
    data-wow-delay="0.1s"
  >
    <div className="position-relative border border-primary pt-5 pb-4 px-4">
      <div
        className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
        style={{ width: 100, height: 100 }}
      >
        <i className="fa fa-code fa-3x text-white" />
      </div>
      <h5 className="mt-4">Software Developers</h5>
      <hr className="w-25 mx-auto bg-primary mb-1" />
      <hr className="w-50 mx-auto bg-primary mt-0" />
      <p className="mb-0">
        <br/>
        <br/>
        Hire our team for a coding spree, tailored apps to match your decree.  
        Scalable, affordable, and truly sublime, we’ll deliver your project on time.
      </p>
    </div>
  </div>
  <div
    className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
    data-wow-delay="0.3s"
  >
    <div className="position-relative border border-primary pt-5 pb-4 px-4">
      <div
        className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
        style={{ width: 100, height: 100 }}
      >
        <i className="fa fa-link fa-3x text-white" />
      </div>
      <h5 className="mt-4">Blockchain Developers</h5>
      <hr className="w-25 mx-auto bg-primary mb-1" />
      <hr className="w-50 mx-auto bg-primary mt-0" />
      <p className="mb-0">
        Building your dApps with seamless flair, blockchain solutions beyond compare.  
        Agile processes to quicken the pace, delivering quality with no time to waste.
      </p>
    </div>
  </div>
  <div
    className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
    data-wow-delay="0.5s"
  >
    <div className="position-relative border border-primary pt-5 pb-4 px-4">
      <div
        className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
        style={{ width: 100, height: 100 }}
      >
        <i className="fa fa-mobile-alt fa-3x text-white" />
      </div>
      <h5 className="mt-4">Application Developers</h5>
      <hr className="w-25 mx-auto bg-primary mb-1" />
      <hr className="w-50 mx-auto bg-primary mt-0" />
      <p className="mb-0">
        Apps for your business, built to grow, with interactive features that truly glow.  
        Affordable and timely, just give us a call, our developers will handle it all.
      </p>
    </div>
  </div>
  <div
    className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
    data-wow-delay="0.1s"
  >
    <div className="position-relative border border-primary pt-5 pb-4 px-4">
      <div
        className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
        style={{ width: 100, height: 100 }}
      >
        <i className="fa fa-apple-alt fa-3x text-white" />
      </div>
      <h5 className="mt-4">Android/iOS Developers</h5>
      <hr className="w-25 mx-auto bg-primary mb-1" />
      <hr className="w-50 mx-auto bg-primary mt-0" />
      <p className="mb-0">
        Need an app for iOS or Android? Our team delivers with skill deployed.  
        Custom plugins and fast processes too, get your app ready with a seamless view.
      </p>
    </div>
  </div>
  <div
    className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
    data-wow-delay="0.3s"
  >
    <div className="position-relative border border-primary pt-5 pb-4 px-4">
      <div
        className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
        style={{ width: 100, height: 100 }}
      >
        <i className="fa fa-cloud fa-3x text-white" />
      </div>
      <h5 className="mt-4">AWS Solution Architect</h5>
      <hr className="w-25 mx-auto bg-primary mb-1" />
      <hr className="w-50 mx-auto bg-primary mt-0" />
      <p className="mb-0">
        With best practices and tools at hand, our AWS architects understand.  
        Scalable solutions, reliable and sure, helping your business grow and endure.
      </p>
    </div>
  </div>
  <div
    className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
    data-wow-delay="0.5s"
  >
    <div className="position-relative border border-primary pt-5 pb-4 px-4">
      <div
        className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
        style={{ width: 100, height: 100 }}
      >
        <i className="fa fa-network-wired fa-3x text-white" />
      </div>
      <h5 className="mt-4">CISCO Track</h5>
      <hr className="w-25 mx-auto bg-primary mb-1" />
      <hr className="w-50 mx-auto bg-primary mt-0" />
      <p className="mb-0">
        Cisco tools to track and grow, certifications to let your expertise show.  
        Monitor progress with ease and care, advancing your skills with solutions rare.
      </p>
    </div>
  </div>
</div>

      </div>
    </div>
    {/* Process Start */}

    {/* Team Start */}
    {/* <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Team
          </h6>
          <h1 className="mb-5">Meet Our Team Member</h1>
        </div>
        <div className="row g-4">
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="team-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/team-1.jpg" alt="" />
              </div>
              <div
                className="position-relative d-flex justify-content-center"
                style={{ marginTop: "-19px" }}
              >
                <a className="btn btn-square mx-1" href="">
                  <i className="fab fa-facebook-f" />
                </a>
                <a className="btn btn-square mx-1" href="">
                  <i className="fab fa-twitter" />
                </a>
                <a className="btn btn-square mx-1" href="">
                  <i className="fab fa-instagram" />
                </a>
              </div>
              <div className="text-center p-4">
                <h5 className="mb-0">Full Name</h5>
                <small>Full Stack Dev</small>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="team-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/team-2.jpg" alt="" />
              </div>
              <div
                className="position-relative d-flex justify-content-center"
                style={{ marginTop: "-19px" }}
              >
                <a className="btn btn-square mx-1" href="">
                  <i className="fab fa-facebook-f" />
                </a>
                <a className="btn btn-square mx-1" href="">
                  <i className="fab fa-twitter" />
                </a>
                <a className="btn btn-square mx-1" href="">
                  <i className="fab fa-instagram" />
                </a>
              </div>
              <div className="text-center p-4">
                <h5 className="mb-0">Full Name</h5>
                <small>UI/UX</small>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="team-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/team-3.jpg" alt="" />
              </div>
              <div
                className="position-relative d-flex justify-content-center"
                style={{ marginTop: "-19px" }}
              >
                <a className="btn btn-square mx-1" href="">
                  <i className="fab fa-facebook-f" />
                </a>
                <a className="btn btn-square mx-1" href="">
                  <i className="fab fa-twitter" />
                </a>
                <a className="btn btn-square mx-1" href="">
                  <i className="fab fa-instagram" />
                </a>
              </div>
              <div className="text-center p-4">
                <h5 className="mb-0">Full Name</h5>
                <small>Mobile dev</small>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
            <div className="team-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/team-4.jpg" alt="" />
              </div>
              <div
                className="position-relative d-flex justify-content-center"
                style={{ marginTop: "-19px" }}
              >
                <a className="btn btn-square mx-1" href="">
                  <i className="fab fa-facebook-f" />
                </a>
                <a className="btn btn-square mx-1" href="">
                  <i className="fab fa-twitter" />
                </a>
                <a className="btn btn-square mx-1" href="">
                  <i className="fab fa-instagram" />
                </a>
              </div>
              <div className="text-center p-4">
                <h5 className="mb-0">Full Name</h5>
                <small>DevOps</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> */}
    {/* Team End */}

    {/* Testimonial Start */}
    {/* <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div className="container">
    <div className="text-center">
      <h6 className="section-title bg-white text-center text-primary px-3">
        Testimonial
      </h6>
      <h1 className="mb-5">Our Clients Say!!!</h1>
    </div>
    <div className="owl-carousel testimonial-carousel position-relative">
    
      <div className="testimonial-item bg-white text-center border p-4">
        <img
          className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
          src="assets/img/testimonial-1.jpg"
          style={{ width: 80, height: 80 }}
          alt="Client 1"
        />
        <h5 className="mb-0">John Doe</h5>
        <p>New York, USA</p>
        <p className="mb-0">
          Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit diam amet
          diam et eos. Clita erat ipsum et lorem et sit.
        </p>
      </div>
      <div className="testimonial-item bg-white text-center border p-4">
        <img
          className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
          src="assets/img/testimonial-2.jpg"
          style={{ width: 80, height: 80 }}
          alt="Client 2"
        />
        <h5 className="mb-0">Jane Doe</h5>
        <p>California, USA</p>
        <p className="mt-2 mb-0">
          Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit diam amet
          diam et eos. Clita erat ipsum et lorem et sit.
        </p>
      </div>
      <div className="testimonial-item bg-white text-center border p-4">
        <img
          className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
          src="assets/img/testimonial-3.jpg"
          style={{ width: 80, height: 80 }}
          alt="Client 3"
        />
        <h5 className="mb-0">Emily Smith</h5>
        <p>London, UK</p>
        <p className="mt-2 mb-0">
          Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit diam amet
          diam et eos. Clita erat ipsum et lorem et sit.
        </p>
      </div>
      <div className="testimonial-item bg-white text-center border p-4">
        <img
          className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
          src="assets/img/testimonial-4.jpg"
          style={{ width: 80, height: 80 }}
          alt="Client 4"
        />
        <h5 className="mb-0">Michael Johnson</h5>
        <p>Paris, France</p>
        <p className="mt-2 mb-0">
          Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit diam amet
          diam et eos. Clita erat ipsum et lorem et sit.
        </p>
      </div>
    </div>
  </div>
</div> */}

    {/* Testimonial End */}  
    </div>
    </>
  )
}
